export const ENTITY_SCORES = {
  FOOTER_POSITION: 'footer',
  INTERSECTION_MARGIN: '300px 0px 300px 0px',

  TYPES: {
    competition: 'competition',
    competitor: 'competitor',
    athlete: 'athlete'
  },

  FILTER_NAMES: {
    recentMatches: 'Recent Matches',
    results: 'results',
    fixtures: 'fixtures',
  },

  URL_FILTERS: {
    recentMatches: 'current',
    results: 'results',
    fixtures: 'fixtures',
  },

  API_FILTERS: {
    recentMatches: 'current',
    results: 'results',
    fixtures: 'fixtures',
  },

  ANALYTICS: {
    DISPLAY_SOURCE: {
      all: -1,
      competitionScores: 1,
      competitorScores: 2,
    },

    FILTERS: {
      recentMatches: 'current',
      results: 'results',
      fixtures: 'fixtures',
    },
  },

  ACTION_HANDLERS: {
    fetchNextPage: 'fetchNextPage',
    populateDataHandler: 'populateDataHandler',
    statePopulation: 'statePopulation',
    filterChange: 'filterChange',
    entityFetch: 'entityFetch',
    gameClick: 'gameClick',
    tabClick: 'tabClick',
    onDropdownFilterChange: 'onDropdownFilterChange'
  },

  EMPTY_STATE: {
    LOGO_SIZE: {
      width: 91,
      height: 86
    }
  },

  FILTERS_INDEX: {
    recent : 0,
    fixtures: 1,
    results: 2
  },

  TOP_BETTING_OPPORTUNITY: {
    byPopular: 1,
    byView: 2
  }
}

ENTITY_SCORES.FILTERS_ARRAY = [{
  id: 0,
  active: true,
  ignorePaging: true,
  key: 'current',
  termKey: 'WEB_DROPDOWN_SCORES_OVERVIEW',
  name: ENTITY_SCORES.FILTER_NAMES.recentMatches,
  analyticsName: ENTITY_SCORES.ANALYTICS.FILTERS.recentMatches,
  toString: () => 'Recent Matches',
  urlFilter: ENTITY_SCORES.API_FILTERS.recentMatches
}, {
  id: 1,
  active: false,
  name: ENTITY_SCORES.FILTER_NAMES.fixtures,
  analyticsName: ENTITY_SCORES.ANALYTICS.FILTERS.fixtures,
  termKey: 'WEB_DROPDOWN_FIXTURES',
  key: 'fixtures',
  toString: () => 'Fixtures',
  urlFilter: ENTITY_SCORES.API_FILTERS.fixtures,
}, {
  id: 2,
  active: false,
  name: ENTITY_SCORES.FILTER_NAMES.results,
  analyticsName: ENTITY_SCORES.ANALYTICS.FILTERS.results,
  termKey: 'WEB_DROPDOWN_RESULTS',
  key: 'results',
  reverse: true,
  toString: () => 'Results',
  urlFilter: ENTITY_SCORES.API_FILTERS.results,
}];

ENTITY_SCORES.FILTERS = {
  [ENTITY_SCORES.FILTER_NAMES.recentMatches]: ENTITY_SCORES.FILTERS_ARRAY[0],
  [ENTITY_SCORES.FILTER_NAMES.fixtures]: ENTITY_SCORES.FILTERS_ARRAY[1],
  [ENTITY_SCORES.FILTER_NAMES.results]: ENTITY_SCORES.FILTERS_ARRAY[2],
}
